<template>
  <v-col
    cols="12"
    class="login"
    :style="`background: linear-gradient(to bottom, ${$env.VUE_APP_ACCENT_COLOR} 0%, #FFFFFF 100%) !important;`"
  >

    <v-col cols="12" md="4" class="mx-auto">
      <v-card elevation="0">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <h1 class="mb-6">
                {{
                  loginForm
                    ? $t("login.connection.title")
                    : $t("login.register.title")
                }}
              </h1>
              <v-alert
                colored-border
                border="top"
                color="error"
                v-model="notValidUser"
              >
                Veuillez cliquer sur le lien de confirmation que vous avez reçu
                dans votre boite mail, si ce n'est pas le cas regardez dans
                votre boite de spam ou contactez-nous par mail sur la boite :
                support@previmeteo.com
              </v-alert>
              <template v-if="loginForm">
                <transition name="fade">
                  <v-form
                    @submit.prevent="login"
                    ref="formLogin"
                    lazy-validation
                  >
                    <v-text-field
                      v-model="user.user_email"
                      :label="$t('login.connection.email')"
                      :rules="[(v) => !!v || $t('error.requiredField')]"
                      autocomplete="username"
                      name="email"
                      ref="formLoginEmail"
                      type="email"
                      dense
                      filled
                      rounded
                    />
                    <v-text-field
                      v-model="user.user_password"
                      :label="$t('login.connection.password')"
                      :rules="[(v) => !!v || $t('error.requiredField')]"
                      autocomplete="current-password"
                      name="password"
                      type="password"
                      dense
                      filled
                      rounded
                    />
                    <a @click="openLostPassword = true">{{
                      $t("lost_pass")
                    }}</a>
                    <v-btn
                      :loading="loginLoading"
                      class="my-3"
                      color="primary"
                      elevation="0"
                      type="submit"
                      block
                      rounded
                      >{{ $t("login.connection.title") }}</v-btn
                    >

                    <v-btn
                      :loading="magicLoginSendLoading"
                      class="my-3"
                      color="primary"
                      elevation="0"
                      type="button"
                      block
                      rounded
                      @click="sendMagicLink"
                      >{{ $t("login.connection.magic") }}</v-btn
                    >

                    <hr class="my-6" />

                    <v-btn
                      elevation="0"
                      block
                      rounded
                      color="info"
                      type="button"
                      to="/register"
                      >{{ $t("login.register.title") }}</v-btn
                    >
                  </v-form>
                </transition>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-dialog width="80vw" v-model="openLostPassword">
        <v-card>
          <v-card-text>
            <v-col>
              <v-alert
                colored-border
                border="top"
                color="success"
                v-model="successLostPassword"
              >
                Un email de changement de mot de passe vient de vous être
                envoyé.
              </v-alert>
              <v-alert
                colored-border
                border="top"
                color="error"
                v-model="errorLostPassword"
              >
                Une erreur s'est produite, veuillez réessayer plus tard.
              </v-alert>
              <v-form @submit.prevent="sendLostPassword()">
                <v-text-field
                  filled
                  rounded
                  placeholder="Email rataché à votre compte"
                  dense
                  v-model="lost_password_email"
                />
                <v-btn @click="sendLostPassword()" block rounded color="primary"
                  >Changer de mot de passe</v-btn
                >
              </v-form>
            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-col class="px-0">
        <v-select
          label="Langue"
          @change="changeLang"
          v-model="lang"
          dense
          filled
          rounded
          :items="[
            { text: '🇫🇷 Français', value: 'fr' },
            { text: '🇬🇧 English', value: 'en' },
          ]"
        />
      </v-col>
    </v-col>

    <v-col
      cols="12"
      md="6"
      class="mx-auto text-center"
      v-if="getPlatform == 'web' && $env.VUE_APP_ORG_NAME == 'pm'"
    >
      <h2 class="mb-6 white--text">{{ $t("our_apps") }}</h2>
      <v-btn
        outlined
        class="mx-3"
        :class="$vuetify.breakpoint.mobile ? 'mb-3' : ''"
        href="https://play.google.com/store/apps/details?id=com.previmeteo.alerts&amp;hl=fr"
        color="white"
      >
        <v-icon>mdi-google-play</v-icon> Play Store
      </v-btn>
      <v-btn
        class="mx-3"
        href="https://apps.apple.com/fr/app/my-previmeteo/id1050964320"
        outlined
        color="white"
      >
        <v-icon>mdi-apple</v-icon> App Store
      </v-btn>
    </v-col>

    <v-snackbar top block v-model="success" color="success">{{
      $t("login.snackbarSuccess")
    }}</v-snackbar>
    <v-snackbar top block v-model="successConfirmEmail" color="success"
      >Email validé avec succès</v-snackbar
    >
    <v-snackbar top block v-model="magicLoginSendSuccess" color="success">{{
      $t("login.magic.snackbarSuccess")
    }}</v-snackbar>
    <v-snackbar top block v-model="loginError" color="error">{{
      $t("login.snackbarError")
    }}</v-snackbar>
    <v-snackbar top block v-model="magicLoginVerifyError" color="error">{{
      $t("login.magic.snackbarError")
    }}</v-snackbar>
    <v-snackbar top block v-model="error" color="error">{{
      $t("error.unknownError")
    }}</v-snackbar>
    <v-overlay v-if="magicLoginVerifyLoading">
      <v-card light>
        <v-card-text>
          <v-col class="text-center">
          <v-progress-circular indeterminate/>
          <h1>Une petite seconde nous vous connectons...</h1>
          </v-col>
        </v-card-text>
      </v-card>
    </v-overlay>
  </v-col>
</template>

<script>
import axios from 'axios';
import { Capacitor } from '@capacitor/core';

import api from '@/api';

export default {
  data: () => ({
    // Form data
    openLostPassword: false,
    successLostPassword: false,
    errorLostPassword: false,
    lost_password_email: null,
    user: {
      user_nom: null,
      user_prenom: null,
      user_email: null,
      user_password: null,
    },
    phoneValid: null,
    // Form settings
    loginForm: true,
    success: false,
    error: false,
    successConfirmEmail: false,
    loading: false,
    loginError: false,
    loginLoading: false,
    magicLoginSendLoading: false,
    magicLoginSendSuccess: false,
    magicLoginVerifyLoading: false,
    magicLoginVerifyError: false,
    registerLoading: false,
    notValidUser: false,
    lang: 'fr',
  }),
  computed: {
    getPlatform() {
      return Capacitor.getPlatform();
    },
    iOS() {
      return Capacitor.getPlatform() == 'ios';
    },
  },
  methods: {
    changeLang() {
      this.$i18n.locale = this.lang;
      localStorage.setItem('lang', this.lang);
    },
    async sendLostPassword() {
      try {
        await api.users.lostPassword(this.lost_password_email, `?flag=${this.$wm.flag}`);
        this.successLostPassword = true;
        localStorage.clear();
      } catch (err) {
        this.errorLostPassword = true;
        console.og(err);
      }
    },
    // Lazy validation on phone input
    phoneValidation(formattedNumber, { number, valid }) {
      this.user.user_phone = number.international;
      this.phoneValid = valid;
    },
    // Login user
    async login() {
      if (!this.$refs.formLogin.validate()) {
        return;
      }

      this.loginLoading = true;
      this.loading = true;

      try {
        const login = await api.login(
          this.user.user_email,
          this.user.user_password,
        );

        await this.onLogged(login);
      } catch (error) {
        console.error(error);
        this.loginError = true;
      }
      this.loading = false;
      this.loginLoading = false;
    },
    // register new user
    async register() {
      this.registerLoading = true;
      if (this.$refs.registerFormRef.validate()) {
        try {
          if (this.$route.query.referrer) {
            this.user.referrer = this.$route.query.referrer;
          }
          this.user.flag = this.$wm.flag;
          await api.registerUser(this.user);

          this.success = true;
          this.loginForm = !this.loginForm;
        } catch (error) {
          console.error(error);
          this.error = true;
        }
      }
      this.registerLoading = false;
    },
    async sendMagicLink() {
      if (!this.$refs.formLoginEmail.validate(true)) {
        return;
      }

      this.magicLoginSendLoading = true;

      try {
        this.user.flag = this.$wm.flag;
        let flag = this.$wm.flag;
        if(flag == 'pm'){
          flag = 'my';
        }
        await api.sendMagicLink(this.user.user_email, flag);
        this.magicLoginSendSuccess = true;
      } catch (error) {
        console.error(error);
        this.error = true;
      }

      this.magicLoginSendLoading = false;
    },
    async verifyMagicToken(magicToken) {
      this.magicLoginVerifyLoading = true;

      try {
        const login = await api.verifyMagicToken(magicToken);
        await this.onLogged(login);
        
      } catch (error) {
        console.error(error);
        this.magicLoginVerifyError = true;
      }

      this.magicLoginVerifyLoading = false;
    },
    async onLogged({ token, user }) {
      if (!user.is_valid) {
        this.notValidUser = true;
        return;
      }
      
      this.$store.dispatch('setToken', token);

      const userData = await api.users.get(user.id_user);
      this.$store.dispatch('setUser', userData);
      
      if (this.$route.query.free_test) {
        await api.registerFreeTest(user.id_user);
      }

      this.$store.dispatch('setIsLogged', true);
      this.$emit('logged');
      this.$router.push(`/${this.$route.query.redirect ?? ''}`).catch(() => {});
    },
  },
  async mounted() {
    this.lang = localStorage.getItem('lang') ?? 'fr';

    if (this.$route.query.magic_token) {
      await this.verifyMagicToken(this.$route.query.magic_token);
      return;
    }

    if (this.$route.query.register) {
      this.loginForm = false;
    }

    if (this.$route.query.access_token) {
      const { data } = await axios.get('https://auth.previmeteo.net/user/me', {
        headers: {
          Authorization: `Bearer ${this.$route.query.access_token}`,
        },
      });

      if (data) {
        const user = await api.users.get(data.user.id_user);
        this.$store.dispatch('setUser', user);
        this.$store.dispatch('setToken', this.$route.query.access_token);
        this.$router.push('/').catch(() => {});
      }
    }

    if (this.$route.query.confirm_email) {
      api.confirm_email(this.$route.query.confirm_email).then((res) => {
        if (res.affectedRows) {
          this.successConfirmEmail = true;
        }
      });
    }
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.login {
  height: 100vh;

  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: scroll !important;
}
</style>
